import { colors } from "../colors";

export const SASCheckboxStyles = {
  "& .MuiSvgIcon-root": {
    fontSize: 24,
  },

  color: colors.gray[300],
  "&.Mui-checked": {
    color: colors.orange.base,
  },
  "&.MuiCheckbox-indeterminate": {
    color: colors.orange[400],
  },
  "&:hover": {
    backgroundColor: `${colors.orange[100]}33`,
    borderRadius: "6px",
  },

  "&.Mui-disabled": {
    color: colors.gray[200],
  },
};
